// Mega Menu Tabs functionality - Simplified Direct Approach
(function() {
  // Function to directly attach click handlers to tab buttons
  function setupTabButtons() {
    const tabButtons = document.querySelectorAll('.tab-button');
    
    tabButtons.forEach(button => {
      // Remove any existing click handlers to prevent duplicates
      button.removeEventListener('click', handleTabClick);
      // Add the click handler
      button.addEventListener('click', handleTabClick);
    });
  }
  
  // Tab click handler function
  function handleTabClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = this;
    const tabToActivate = button.getAttribute('data-tab');
    const container = button.closest('.mega-menu-tabs-with-content');
    
    if (!container) return;
    
    // Deactivate all tabs in this container
    container.querySelectorAll('.tab-button').forEach(btn => {
      btn.classList.remove('tab-button--active');
    });
    
    // Activate this tab
    button.classList.add('tab-button--active');
    
    // Hide all content in this container
    container.querySelectorAll('.mega-menu-tab-content').forEach(content => {
      content.classList.remove('tab-content--active');
    });
    
    // Show the selected content
    const tabContent = container.querySelector('.tab-content--' + tabToActivate);
    if (tabContent) {
      tabContent.classList.add('tab-content--active');
    }
    
    // Update view all buttons
    container.querySelectorAll('.mega-menu-view-all').forEach(btn => {
      btn.classList.remove('btn-active');
    });
    
    const viewAllBtn = container.querySelector('.btn-tab-' + tabToActivate);
    if (viewAllBtn) {
      viewAllBtn.classList.add('btn-active');
    }
  }
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Set up initial tab buttons
    setupTabButtons();
    
    // Set up a MutationObserver to watch for new tab buttons being added
    const observer = new MutationObserver(function(mutations) {
      let shouldSetupTabs = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1 && (
                node.classList?.contains('mega-menu-tabs-with-content') || 
                node.querySelector?.('.mega-menu-tabs-with-content') ||
                node.classList?.contains('tab-button') ||
                node.querySelector?.('.tab-button')
            )) {
              shouldSetupTabs = true;
              break;
            }
          }
        }
      });
      
      if (shouldSetupTabs) {
        // Wait a moment for the DOM to settle
        setTimeout(setupTabButtons, 50);
      }
    });
    
    // Start observing the document
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
    
    // Also set up click handlers for menu items to ensure tabs are initialized
    document.querySelectorAll('.submenu__item--parent').forEach(item => {
      item.addEventListener('click', function() {
        // Wait for submenu to open
        setTimeout(setupTabButtons, 100);
      });
      
      // Also handle hover for desktop
      item.addEventListener('mouseenter', function() {
        setTimeout(setupTabButtons, 100);
      });
    });
    
    // Set up a periodic check for tab buttons that might have been missed
    setInterval(setupTabButtons, 1000);
  });
})();